import React, { useState, useEffect } from 'react'
import { Col, Tag, Table, Modal, message, Button, Tooltip, Form, DatePicker, Input, Select, Upload, Image, Empty, Cascader } from "antd";
import { PlusOutlined, LoadingOutlined, UploadOutlined } from '@ant-design/icons';
const { RangePicker } = DatePicker;
const { TextArea } = Input;
import InspectionApi from '@api/inspectionnew'
import stationApi from '@api/station'
import SearchForm from '@components/SearchForm'
import DepartmentApi from '@api/department'
import HandleButton from '@components/HandleButton'
import Title from '@/components/Title'
import { connect } from 'react-redux'
import moment from 'moment';
import { getStationData, getTreeData, toolMouseTip } from '@utils/common'
import AddModel from './add'
import './index.scss'
import '../style.scss'

const StatusData = ['待处理', '处理中', '完成', '关闭', '验收']
const colorStatus = ['#FF3819', '#2db7f5', '#87d068', '#BDBDBD', '#2D99FF']

// 指令单状态
const instructStatusLs = ['待处理', '处理中', '完成', '关闭']

const OrderCom = (props) => {
  const [form] = Form.useForm();
  const [recordingForm] = Form.useForm();
  const [loading, setLoading] = useState(false)
  const [loadBtn, setLoadBtn] = useState(false)
  const [data, setData] = useState([]) // 表格数据
  const [deleteVisible, setDelVisible] = useState(false)
  const [editVisible, setEditVisible] = useState(false)
  const [editTitle] = useState('新增缺陷单')
  const [rowParams, setRowParams] = useState()
  const [acceptVisible, setAcceptVisible] = useState(false)
  const [checkacceptVisible, setCheckacceptVisible] = useState(false)
  const [rateTionModel, setRateTionModel] = useState(false)
  // 操作id
  const [modifyId, setModifyId] = useState()
  const [uploadLoading, setUploadLoading] = useState(false);
  const [detailModelVisible, setDetailModelVisible] = useState(false);
  const [detail, setDetail] = useState({})
  const [imageUrl, setImageUrl] = useState();
  const [relationDefectsLs, setRelationDefectsLs] = useState([])
  const [selectionType, setSelectionType] = useState('checkbox');
  const [defectDetailImgVisibel, setDefectDetailImgVisibel] = useState(false)
  const [defectDetailSrcImgVisibel, setDefectDetailSrcImgVisibel] = useState(false)
  const [recordImageUrls, setRecordImageUrls] = useState([])
  const [recordDefectId, setRecordDefectId] = useState()
  const [recordModal, setRecordModal] = useState(false)
  const [detailSourceImgsVisi, setDetailSourceImgsVisi] = useState([])
  // 指派相关
  const [specifyModal, setSpecifyModal] = useState(false)
  const [specifyForm] = Form.useForm()
  const [deptList, setDeptList] = useState([])
  const [personList, setPersonList] = useState([])
  const [specifyId, setSpecifyId] = useState()
  const [specifyStaionId, setSpecifyStaionId] = useState()
  // 查询参数
  // 搜索相关参数
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
    name: ''
  })
  const [total, setTotal] = useState(0)

  // 关联缺陷单搜索参数
  const [relationSearchParams, setRelationSearchParams] = useState({
    pageNum: 1,
    pageSize: 10
  })
  const [relationTotal, setRelationTotal] = useState(0)  // 关联列表总数
  const [ids, setIds] = useState([])     // 关联缺陷单的ids
  const [relationId, setRelationId] = useState()    // 当前关联的id

  const [dateSearch] = useState([{
    label: '发现时间',
    name: 'discoveryTime',
    span: 8,
    labelCol: 6,
    showTime: true,
    tag: 'rangePicker'
  }])


  // 搜索
  const [inputList] = useState([{
    label: '缺陷描述:',
    name: "deffectRemark",
    message: "请输入缺陷描述",
    span: 8,
    labelCol: 6
  }])
  const [selectList, setSelectList] = useState([])

  const [stationData, setStationData] = useState()
  const [cascaderLs, setCascaderLs] = useState([{
    label: '设备',
    name: 'deviceRelevancyId',
    message: "请选择设备",
    span: 8,
    labelCol: 6,
    options: []
  }])

  useEffect(() => {
    getStationList()
    return () => { }
  }, [])
  // 获取厂站列表
  const getStationList = async () => {
    const data = getStationData(props.userInfo.stationIds ? props.userInfo.stationIds : '-1', props.userInfo.stationAliasName)
    // 缺陷等级列表
    const res = await InspectionApi.defectLevelLs({ pageNum: 1, pageSize: 10 })

    const selectls = [
      {
        attr: { allowClear: true },
        label: '厂站:',
        name: "stationId",
        message: "请选择厂站",
        options: data,
        span: 8,
        labelCol: 6,
        change: (e) => changeSearchStation(e)
      },
      {
        attr: { allowClear: true },
        label: '缺陷等级:',
        name: "defectLevelId",
        message: "请选择缺陷等级",
        options: res.data ? res.data.map((item, i) => { return { title: item.defectLevelName, value: item.id, checked: false } }) : [],
        span: 8,
        labelCol: 6
      },
      {
        attr: { allowClear: true },
        label: '是否安全隐患:',
        name: "safetyPerilFlag",
        message: "请选择是否安全隐患",
        options: [
          {
            title: '否',
            value: 0
          },
          {
            title: '是',
            value: 1
          }
        ],
        span: 8,
        labelCol: 6
      },
      {
        attr: { allowClear: true },
        label: '状态:',
        name: "handleStatus",
        message: "请选择状态",
        options: [
          {
            title: '待处理',
            value: 0
          },
          {
            title: '处理中',
            value: 1
          },
          {
            title: '关闭',
            value: 3
          },
          {
            title: '验收',
            value: 4
          }
        ],
        span: 8,
        labelCol: 6
      }
    ]
    setSelectList(selectls)
    setStationData(data)
  }

  useEffect(() => {
    listByRole()
    return () => { }
  }, [searchParams])

  const listByRole = () => {
    setLoading(true)
    InspectionApi.defectOrderCenter({ ...searchParams, status: searchParams.status * 1 }).then(res => {
      setLoading(false)
      if (res.status == 0 && res.data) {
        setData(res.data?.data || [])
        setTotal(res.data?.total)
      }
    })
  }

  const changeSearchStation = (e) => {
    stationApi.getDeviceByStationId({ stationId: e }).then(res => {
      setCascaderLs([
        {
          label: '设备',
          name: 'deviceRelevancyId',
          message: "请选择设备",
          span: 8,
          labelCol: 6,
          options: getTreeData(res.data)
        }
      ])
    })
  }

  // 分页
  const handleTableChange = (pagination) => {
    let params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    }
    setSearchParams(params)
  };

  const handleTableChange1 = (pagination) => {
    let params = {
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    }
    setRelationSearchParams(params)
  };

  /**
   * 搜索
   * @param params
   */
  const search = (paramsObj) => {
    if (paramsObj.discoveryTime) {
      paramsObj.discoveryTimeBegin = moment(paramsObj.discoveryTime[0]._d).format('YYYY-MM-DD HH:mm:ss')
      paramsObj.discoveryTimeEnd = moment(paramsObj.discoveryTime[1]._d).format('YYYY-MM-DD HH:mm:ss')
    }
    delete paramsObj.discoveryTime
    paramsObj.deviceRelevancyId = paramsObj.deviceRelevancyId ? paramsObj.deviceRelevancyId[paramsObj.deviceRelevancyId.length - 1] : ''
    let params = {
      ...paramsObj,
      pageNum: 1,
      pageSize: 10,
      stationId: paramsObj.stationId && paramsObj.stationId * 1
    }
    setSearchParams(params)
  }

  const cancel = () => {
    setDelVisible(false)
    setAcceptVisible(false)
    setCheckacceptVisible(false)
    form.resetFields();
    // setParams({})
  }
  // 关闭工单
  const handleClose = (id) => {
    InspectionApi.closeDefectOrder({ id }).then(res => {
      if (res.status == 0) {
        message.success('关闭成功')
        listByRole()
      }
    })
  }

  // 接受工单
  const accept = () => {
    form.validateFields().then(values => {
      if (!values) {
        return;
      }
      InspectionApi.defectAccept({ id: rowParams.id, planCloseTime: values.planCloseTime }).then(res => {
        if (res.status == 0) {
          message.success('接受成功')
          listByRole()
          setAcceptVisible(false)
        }
      })
    })

  }

  //验收
  const checkaccept = () => {
    form.validateFields().then(values => {
      if (!values) {
        return;
      }
      InspectionApi.checkAccept({ id: modifyId, checkAcceptDesc: values.checkAcceptDesc }).then(res => {
        if (res.status == 0) {
          message.success('验收成功')
          setCheckacceptVisible(false)
          form.resetFields()
          listByRole()
        }
      })
    })
  }

  const columns1 = [
    {
      title: '缺陷描述',
      dataIndex: 'deffectRemark',
      align: 'center',
      key: 'deffectRemark',
      render: _t => <Tooltip placement="top" title={_t}>{_t.length > 6 ? _t.substring(0, 5) + '…' : _t}</Tooltip>
    },
    {
      title: '所属厂站',
      dataIndex: 'stationName',
      align: 'center',
      key: 'stationName',
    },
    // {
    //   title: '来源',
    //   dataIndex: 'sourceType',
    //   align: 'center',
    //   key: 'sourceType',
    //   render: (obj) => obj ? '保养任务' : '巡检任务'
    // }
  ]

  const columns = [
    {
      title: '缺陷等级',
      dataIndex: 'defectLevelName',
      align: 'center',
      key: 'defectLevelName'
    },
    {
      title: '缺陷描述',
      dataIndex: 'deffectRemark',
      align: 'center',
      key: 'deffectRemark',
      render: _t => toolMouseTip(_t, 10)
    },
    {
      title: '所属厂站',
      dataIndex: 'stationName',
      align: 'center',
      key: 'stationName',
    },
    {
      title: '设备名称',
      dataIndex: 'deviceRelevancyName',
      align: 'center',
      key: 'deviceRelevancyName',
    },
    {
      title: '状态',
      dataIndex: 'handleStatus',
      align: 'center',
      key: 'handleStatus',
      render: val => <Tag color={colorStatus[val - 0]}>{StatusData[val - 0]}</Tag>
    },
    {
      title: '超时状态',
      dataIndex: 'timeoutStatus',
      align: 'center',
      key: 'timeoutStatus',
      render: _t => _t == 1 ? <Tag color="#FF3819">超时</Tag> : <Tag color="#2db7f5">未超时</Tag>
    },
    {
      title: '安全隐患',
      dataIndex: 'safetyPerilFlag',
      align: 'center',
      key: 'safetyPerilFlag',
      render: val => val ? '是' : '否'
    },
    {
      title: '创建时间',
      dataIndex: 'createAt',
      align: 'center',
      key: 'createAt'
    },
    {
      title: '计划关闭时间',
      dataIndex: 'planCloseTime',
      align: 'center',
      key: 'planCloseTime'
    },
    {
      title: '操作',
      key: 'operation',
      width: 150,
      align: "center",
      fixed: 'right',
      render: (record) => {
        return (
          <>
            {
              props.userInfo.btnResources.indexOf('defect:orderCenter:specify') !== -1 &&
              (record.handleStatus !== 3 && record.handleStatus !== 4) &&
              <Button className='success' size='small' type='primary' onClick={() => showSpecifyModal(record)}>指派</Button>
            }
            {props.userInfo.btnResources.indexOf('defect:orderCenter:info') !== -1 && <Button size='small' type='primary' onClick={() => showInfoDetail(record.id)} style={{ margin: '0 5px' }}>详情</Button>}
          </>
        )
      }
    }
  ]

  // 详情
  const showInfoDetail = (id) => {
    InspectionApi.defectOrderCenterInfo({ id }).then(res => {
      if (res.status !== '0') return
      if (res.data.child && res.data.child.length > 0) {
        let ary = []
        res.data.child.forEach(item => {
          if (item.imageUrls && item.imageUrls.length > 0) {
            ary.push(false)
          }
        })
        setDetailSourceImgsVisi(ary)
      }
      setDetail(res.data)
      setDetailModelVisible(true)
    })
  }

  // 指派
  const showSpecifyModal = async (record) => {
    setSpecifyId(record.id)
    setSpecifyStaionId(record.stationId)
    setSpecifyModal(true)
    DepartmentApi.getDeptForTree({}).then(res => {
      if (res.status === '0') {
        setDeptList(res.data)
      }
    })
  }

  const closeSpecifyModal = () => {
    specifyForm.resetFields()
    setSpecifyModal(false)
  }

  const changeTransferDept = (e) => {
    if (!e) return
    let params = {
      deptId: e[e.length - 1],
      stationId: specifyStaionId
    }
    DepartmentApi.getDeptHeadersByDeptId(params).then(res => {
      if (res.status !== '0') return
      setPersonList(res.data)
    })
  }

  const submitSpecify = () => {
    specifyForm.validateFields().then(values => {
      if ( !values ) return
      const params = {
        deptId: values.deptId[values.deptId.length-1],
        deptLeaderId: values.deptLeaderId,
        id: specifyId
      }
      InspectionApi.defectOrderCenterSpecify(params).then(res => {
        if (res.status === '0') {
          message.success('指派成功')
          closeSpecifyModal()
          listByRole()
        }
      })
    })
  }

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';

    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
    }

    const isLt2M = file.size / 1024 / 1024 < 2;

    if (!isLt2M) {
      message.error('Image must smaller than 2MB!');
    }

    return isJpgOrPng && isLt2M;
  };

  const uploadRecordImg = (info) => {
    const { file } = info
    if (file.status === 'done') {
      const { response: res } = file
      if (res.status !== '0') return
      setRecordImageUrls([...recordImageUrls, res.data.url])
    }
  }

  const removeRecordImg = (info) => {
    const { response: res } = info
    const url = res.data.url
    const params = recordImageUrls
    const index = params.findIndex(item => item === url)
    params.splice(index, 1)
    setRecordImageUrls([...params])
  }

  const submiteRecord = () => {
    recordingForm.validateFields().then(values => {
      if (!values) return
      const params = {
        ...values,
        imageUrls: recordImageUrls,
        id: recordDefectId
      }
      InspectionApi.defectOrderSupplement(params).then(res => {
        if (res.status === '0') {
          message.success('补录成功')
          closeRecordModal()
        }
      })

    })
  }
  const closeRecordModal = () => {
    setRecordModal(false)
    recordingForm.resetFields()
    setRecordImageUrls([])
  }
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      // selectedRowKeys: 选中的ids
      // selectedRows: 选中的一列
      const ary = []
      selectedRows.forEach(item => {
        ary.push(item.id)
      })
      setIds(ary)
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === 'Disabled User',
      // Column configuration not to be checked
      name: record.name,
    }),
  };

  // 
  const submiteRetion = () => {
    if (!ids.length) return message.error('请选择要关联的缺陷单')
    InspectionApi.defectRelation({ id: relationId, ids }).then(res => {
      if (res.status !== '0') return
      message.success('关联成功')
      setIds([])
      setRateTionModel(false)
      listByRole()
    })
  }

  const showRelationDefects = (stationId, relationId) => {
    InspectionApi.defectQuery({ ...relationSearchParams, stationId, queryRelation: 1, id: relationId }).then(res => {
      setRelationDefectsLs(res.data.data)
      setRelationTotal(res.data.total)
      setRateTionModel(true)
      setRelationId(relationId)
    })
  }

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        上传图片
      </div>
    </div>
  );
  return (
    <div className='baseContent boundary'>
      <div className='title'>
        {/* <Title title="厂站列表" style={{ marginLeft: '24px' }}></Title> */}
        <div style={{ marginLeft: '24px' }}>
          <SearchForm span={6} cascaderLs={cascaderLs} inputList={inputList} dateSearch={dateSearch} selectList={selectList} onSearch={search} />
        </div>
        {/* <div style={{ textAlign: 'right', margin: '10px' }}>
          {
            props.userInfo.btnResources.indexOf('defect:order:add') !== -1 &&
            <Button type='primary' onClick={() => { setRowParams(null); setEditVisible(true) }}>新增</Button>
          }
        </div> */}
        <div >
          <Table
            className='Table'
            scroll={{ x: columns.length * 200 }}
            columns={columns}
            dataSource={data}
            rowKey={record => record.id}
            pagination={{
              current: searchParams.pageNum,
              pageSize: searchParams.pageSize,
              showQuickJumper: true,
              showSizeChanger: true,
              showTotal: total => `共${total}条数据`,
              total: total
            }}
            onChange={handleTableChange}
            loading={loading}
          />
        </div>
        {
          acceptVisible &&
          <Modal
            title='接收缺陷单'
            width={600}
            open={acceptVisible}
            onCancel={cancel}
            confirmLoading={loadBtn}
            onOk={accept}>
            <Form form={form}
              layout="horizontal"
            >
              <Col span={18}>
                <Form.Item
                  label='计划关闭时间'
                  name='planCloseTime'
                  rules={[{ required: true, message: '请选择计划关闭时间!' }]}
                >
                  <DatePicker
                    format="YYYY-MM-DD HH:mm:ss"
                    // disabledDate={disabledDate}
                    // disabledTime={disabledDateTime}
                    showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }}
                  />
                </Form.Item>
              </Col>
            </Form>
          </Modal>
        }
        {
          checkacceptVisible &&
          <Modal
            title='验收缺陷单'
            width={600}
            open={checkacceptVisible}
            onCancel={cancel}
            confirmLoading={loadBtn}
            onOk={checkaccept}>
            <Form form={form}
              layout="horizontal"
            >
              <Col span={18}>
                <Form.Item label='验收说明' name="checkAcceptDesc" rules={[{ required: true, message: '请输入验收说明!' }]}>
                  <Input.TextArea row={4} placeholder={'请输入验收说明'} />
                </Form.Item>
              </Col>
            </Form>
          </Modal>
        }
        {
          deleteVisible &&
          <Modal
            title='详情'
            width={600}
            open={deleteVisible}
            onCancel={cancel}
            confirmLoading={loadBtn}
            onOk={cancel}>
            <Form
              layout="horizontal"
            >
              <Form.Item label='任务名称'>
                {rowParams.title}
              </Form.Item>
              <Form.Item label='所属场站'>
                {rowParams.stationName}
              </Form.Item>
              <Form.Item label='缺陷状态'>
                {StatusData[rowParams.status]}
              </Form.Item>
              <Form.Item label='缺陷内容'>
                {rowParams.content}
              </Form.Item>
              <Form.Item label='创建时间'>
                {rowParams.createAt}
              </Form.Item>
              <Form.Item label='更新时间'>
                {rowParams.updateAt}
              </Form.Item>
            </Form>
          </Modal>
        }
        {editVisible && <AddModel stationData={stationData} visible={editVisible} title={editTitle} formData={rowParams} cancel={(bool) => { setEditVisible(false); bool && listByRole() }} />}
        {/* 详情弹框 */}
        <Modal title="详情" open={detailModelVisible} width={800} onOk={() => { setDetailModelVisible(false) }} onCancel={() => { setDetailModelVisible(false) }}>
          <div className='defect-detail-td'>
            <div className='defect-detail-title'>{detail.deffectRemark}</div>
            <div className='defect-detail-status'>●&nbsp;&nbsp;{StatusData[detail.handleStatus]}</div>
          </div>
          <div className='defect-detail-bd'>
            <div className='defect-detail-bd-item'>
              <div className='defect-detail-item-lable'>厂站名称</div>
              <div className='defect-detail-item-desc'>{detail.stationName}</div>
            </div>
            <div className='defect-detail-bd-item'>
              <div className='defect-detail-item-lable'>创建人</div>
              <div className='defect-detail-item-desc'>{detail.createByName}</div>
            </div>
            <div className='defect-detail-bd-item'>
              <div className='defect-detail-item-lable'>设备</div>
              <div className='defect-detail-item-desc'>{detail.deviceRelevancyName}</div>
            </div>
            <div className='defect-detail-bd-item'>
              <div className='defect-detail-item-lable'>缺陷等级</div>
              <div className='defect-detail-item-desc'>{detail.defectLevelName}</div>
            </div>
            <div className='defect-detail-bd-item'>
              <div className='defect-detail-item-lable'>缺陷建议操作</div>
              <div className='defect-detail-item-desc'>{detail.defectLevelInstruct}</div>
            </div>
            {/* <div className='defect-detail-bd-item'>
                <div className='defect-detail-item-lable'>来源类型</div>
                <div className='defect-detail-item-desc'>{detail.sourceType ? '保养任务' : '巡检任务'}</div>
              </div> */}
            <div className='defect-detail-bd-item'>
              <div className='defect-detail-item-lable'>是否安全隐患</div>
              <div className='defect-detail-item-desc'>{detail.safetyPerilFlag ? '是' : '否'}</div>
            </div>
            <div className='defect-detail-bd-item'>
              <div className='defect-detail-item-lable'>验收说明</div>
              <div className='defect-detail-item-desc'>{detail.checkAcceptDesc ? detail.checkAcceptDesc : '-'}</div>
            </div>
            <div className='defect-detail-bd-item'>
              <div className='defect-detail-item-lable'>创建时间</div>
              <div className='defect-detail-item-desc'>{detail.createAt}</div>
            </div>
            <div className='defect-detail-bd-item'>
              <div className='defect-detail-item-lable'>计划关闭时间</div>
              <div className='defect-detail-item-desc'>{detail.planCloseTime}</div>
            </div>
            <div className='defect-detail-bd-item'>
              <div className='defect-detail-item-lable'>发现时间</div>
              <div className='defect-detail-item-desc'>{detail.discoveryTime}</div>
            </div>
            <div className='defect-detail-bd-item'>
              <div className='defect-detail-item-lable'>超时状态</div>
              <div className='defect-detail-item-desc'>{detail.timeoutStatus == 1 ? '超时' : '未超时'}</div>
            </div>
            <div className='defect-detail-bd-img'>
              <div className='defect-detail-item-lable'>图片展示</div>
              {
                detail.imageUrls && detail.imageUrls.length > 0 ? <div className='defect-detail-item-imglist'>
                  <Image
                    preview={{
                      visible: false,
                    }}
                    width={200}
                    src={detail.imageUrls[0]}
                    onClick={() => setDefectDetailImgVisibel(true)}
                  />

                  <div style={{ display: 'none' }}>
                    <Image.PreviewGroup
                      preview={{
                        visible: defectDetailImgVisibel,
                        onVisibleChange: (vis) => setDefectDetailImgVisibel(vis),
                      }}
                    >
                      {
                        detail.imageUrls.map((item, index) => {
                          return <Image src={item} key={index} />
                        })
                      }
                    </Image.PreviewGroup>
                  </div>
                </div> : <Empty description="暂无图片" />
              }
            </div>
          </div>
          <div className='defect-details-list-item'>
            <div className='defect-details-list-item-td'>
              <div className='defect-detail-item-lable'>关联缺陷单</div>
            </div>
            {
              detail.child && detail.child.length > 0 && detail.child.map((item, index) => {
                return (
                  <div key={item.id}>
                    <div className='defect-details-list-item-bd'>
                      <div className='defect-details-item-content'>
                        <div className='defect-details-item-content-label'>缺陷描述</div>
                        <div className='defect-details-item-content-text'>
                          <Tooltip placement="top" title={item.deffectRemark}>{item.deffectRemark.length > 6 ? item.deffectRemark.substring(0, 5) + '…' : item.deffectRemark}</Tooltip>
                        </div>
                      </div>
                      <div className='defect-details-item-content'>
                        <div className='defect-details-item-content-label'>是否安全隐患</div>
                        <div className='defect-details-item-content-text'>
                          {item.safetyPerilFlag ? '是' : '否'}
                        </div>
                      </div>
                      <div className='defect-details-item-content'>
                        <div className='defect-details-item-content-label'>发现时间</div>
                        <div className='defect-details-item-content-text'>{item.discoveryTime}</div>
                      </div>
                      <div className='defect-details-item-content'>
                        <div className='defect-details-item-content-label'>计划关闭时间</div>
                        <div className='defect-details-item-content-text'>{item.planCloseTime}</div>
                      </div>
                      <div className='defect-details-item-content'>
                        <div className='defect-details-item-content-label'>图片</div>
                        <div className='defect-details-item-content-text'>
                          {
                            item.imageUrls && item.imageUrls.length > 0 ? <div className='defect-detail-item-imglist'>
                              <Image
                                preview={{
                                  visible: false,
                                }}
                                width={100}
                                src={item.imageUrls[0]}
                                onClick={() => {
                                  let p = detailSourceImgsVisi
                                  p[index] = true
                                  setDetailSourceImgsVisi([...p])
                                }}
                              />

                              <div style={{ display: 'none' }}>
                                <Image.PreviewGroup
                                  preview={{
                                    visible: detailSourceImgsVisi[index],
                                    onVisibleChange: (vis) => {
                                      let p = detailSourceImgsVisi
                                      p[index] = vis
                                      setDetailSourceImgsVisi([...p])
                                    },
                                  }}
                                >
                                  {
                                    item.imageUrls.map((item, index) => {
                                      return <Image src={item} key={index} />
                                    })
                                  }
                                </Image.PreviewGroup>
                              </div>
                            </div> : '暂无图片'
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </div>
          <div className='defect-details-list'>
            <div className='defect-details-list-item'>
              <div className='defect-details-list-item-td'>
                <div className='defect-detail-item-lable'>关联指令单</div>
              </div>
              {
                detail.instructOrders && detail.instructOrders.length > 0 && detail.instructOrders.map(item => {
                  return (
                    <div className='defect-details-list-item-bd' key={item.id}>
                      <div className='defect-details-item-content'>
                        <div className='defect-details-item-content-label'>指令内容</div>
                        <div className='defect-details-item-content-text'>{item.instructContent}</div>
                      </div>
                      <div className='defect-details-item-content'>
                        <div className='defect-details-item-content-label'>开始时间</div>
                        <div className='defect-details-item-content-text'>{moment(item.beginTime).format('YYYY-MM-DD HH:mm:ss')}</div>
                      </div>
                      <div className='defect-details-item-content'>
                        <div className='defect-details-item-content-label'>结束时间</div>
                        <div className='defect-details-item-content-text'>{moment(item.endTime).format('YYYY-MM-DD HH:mm:ss')}</div>
                      </div>
                      <div className='defect-details-item-content'>
                        <div className='defect-details-item-content-label'>状态</div>
                        <div className='defect-details-item-content-text'>{instructStatusLs[item.handleStatus]}</div>
                      </div>
                    </div>
                  )
                })
              }
            </div>
            <div className='defect-details-list-item'>
              <div className='defect-details-list-item-td'>
                <div className='defect-detail-item-lable'>关联工单</div>
              </div>
              {
                detail.workOrders && detail.workOrders.length > 0 && detail.workOrders.map(item => {
                  return (
                    <div key={item.id}>
                      <div className='defect-details-list-item-bd'>
                        <div className='defect-details-item-content'>
                          <div className='defect-details-item-content-label'>工单内容</div>
                          <div className='defect-details-item-content-text'>
                            <Tooltip placement="top" title={item.workOrderContent}>{item.workOrderContent.length > 6 ? item.workOrderContent.substring(0, 5) + '…' : item.workOrderContent}</Tooltip>
                          </div>
                        </div>
                        <div className='defect-details-item-content'>
                          <div className='defect-details-item-content-label'>开始时间</div>
                          <div className='defect-details-item-content-text'>{item.beginTime ? moment(item.beginTime).format('YYYY-MM-DD HH:mm:ss') : ''}</div>
                        </div>
                        <div className='defect-details-item-content'>
                          <div className='defect-details-item-content-label'>结束时间</div>
                          <div className='defect-details-item-content-text'>2022-8-20 16:00:00</div>
                        </div>
                        <div className='defect-details-item-content'>
                          <div className='defect-details-item-content-label'>状态</div>
                          <div className='defect-details-item-content-text error'>未完成</div>
                        </div>
                      </div>
                    </div>
                  )
                })
              }
            </div>
          </div>
        </Modal>
        {/* 关联缺陷单弹框 */}
        <Modal width={800} title="关联缺陷单" open={rateTionModel} onCancel={() => (setRateTionModel(false), setIds([]))} onOk={submiteRetion}>
          <Table
            rowSelection={{
              type: selectionType,
              ...rowSelection,
            }}
            pagination={{
              current: relationSearchParams.pageNum,
              pageSize: relationSearchParams.pageSize,
              showQuickJumper: true,
              showSizeChanger: true,
              showTotal: relationTotal => `共${relationTotal}条数据`,
              total: relationTotal
            }}
            onChange={handleTableChange1}
            rowKey={record => record.id}
            columns={columns1}
            dataSource={relationDefectsLs}
          />
        </Modal>
        {/* 补录 */}
        {
          recordModal &&
          <Modal
            title="补录"
            open={recordModal}
            onCancel={closeRecordModal}
            onOk={submiteRecord}
          >
            <Form
              layout="horizontal"
              form={recordingForm}
            >
              <Form.Item
                label='缺陷描述'
                name='deffectRemark'
                rules={[{ required: true, message: '请输入缺陷描述!' }]}
              >
                <TextArea rows={3} placeholder="请输入缺陷描述" />
              </Form.Item>
              <Form.Item
                label='图片'
              >
                <Upload
                  name='file'
                  action={window.globalConfig.UPLOADER}
                  headers={{ authorization: sessionStorage.getItem('token') }}
                  beforeUpload={(e) => beforeUpload(e)}
                  onChange={(e) => uploadRecordImg(e)}
                  onRemove={(e) => removeRecordImg(e)}
                >
                  <Button icon={<UploadOutlined />}>上传图片</Button>
                </Upload>
              </Form.Item>
            </Form>
          </Modal>
        }
        {/* /补录 */}
        {/* 指派 */}
        <Modal
          title="指派"
          open={specifyModal}
          onCancel={closeSpecifyModal}
          onOk={submitSpecify}
        >
          <Form
          name="basic"
          form={specifyForm}
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 18,
          }}
          autoComplete="off"
        >
          <Form.Item label='负责部门' name="deptId" rules={[{ required: true, message: '请选择负责部门' }]}>
            <Cascader
              fieldNames={{
                label: 'name',
                value: 'id',
                children: 'children',
              }}
              options={deptList} 
              onChange={(e) => { changeTransferDept(e) }} 
              placeholder="请选择" />
          </Form.Item>
          <Form.Item label='部门负责人' name="deptLeaderId" rules={[{ required: true, message: '请选择部门负责人' }]}>
            <Select placeholder="请选择部门负责人">
              {personList.length > 0 && personList.map(item => {
                return <Select.Option value={item.id} key={item.id}>{item.realName}</Select.Option>
              })}
            </Select>
          </Form.Item>
        </Form>
        </Modal>
        {/* /指派 */}
      </div>
    </div >
  )
}

const mapStateToProps = state => {
  return {
    ...state.Common
  }
};

export default connect(mapStateToProps)(OrderCom)
